<template>
  <div id="app">
    <v-loading ref="loading"></v-loading>
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </div>
</template>

<script>
import Loading from './Loading'

// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component
    return components
  }, {})

export default {

  components: {
    'v-loading': Loading
  },

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  data: () => ({
    layout: null,
    defaultLayout: 'app'
  }),

  mounted () {
    this.$loading = this.$refs.loading
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    }
  }
}
</script>
<style>
@font-face {
  font-family: "SFPro-Regular";
  src: url("/fonts/SFPro/TrueType/SFProDisplay-Regular.ttf");
}
.theme--light.v-application {
    font-family: "SFPro-Regular";
}
.v-btn{
  text-transform: none;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue